export default __webpack_public_path__ + "static/media/ontario-fresh-banner.389f0611.jpg";